class MCartSpecialOfferDrawer extends HTMLElement {
    constructor() {
        super(),
        this.cartDrawerInner = this.querySelector(".m-cart-special-offer-drawer__inner"),
        this.cartDrawerCloseIcon = this.querySelector(".m-cart-special-offer-drawer__close"),
        this.cartDrawerCheckoutBtn = this.querySelector(".m-cart-special-offer-drawer__btn"),
        this.cartOverlay = this.querySelector(".m-cart__overlay"),
        this.rootUrl = window.Shopify.routes.root,
        this.setHeaderCartIconAccessibility(),
        this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this)),
        (document.querySelector('.m-cart-special-offer-drawer__btn') !== null)? (this.cartDrawerCheckoutBtn.addEventListener("click", this.close.bind(this))):false,
        this.addEventListener("click", (t=>{
          t.target.closest(".m-cart-special-offer-drawer__inner") !== this.cartDrawerInner && this.close()
        }
        ))
        window.cartSpecialOfferDrawer = this;
        freeShippingMsg();
    }
    setHeaderCartIconAccessibility() {
        document.querySelectorAll(".open_shade_SpecialOffer").forEach((t=>{
           
           
            t.setAttribute("role", "button"),
            t.setAttribute("aria-haspopup", "dialog"),
            t.addEventListener("click", (e=>{
              
                console.log(t.getAttribute('data-number')),
                MinimogSettings.enable_cart_drawer && (e.preventDefault(),
                this.open(t))
            }
            ))
        }
        ))
    }
    open(t) {
        freeShippingMsg();
        t && this.setActiveElement(t),
          console.log("here"+t.getAttribute('data-number')),
          

         document.querySelectorAll('.cart_upsell_drawer_inner_items').forEach((aa=>{
            console.log(aa.getAttribute('data-setid'));
            if(aa.getAttribute('data-setid') == t.getAttribute('data-number')){
            //  aa.classList.remove('hidden');
            }else{
              aa.remove();
            }
        })),
        this.classList.add("m-cart-special-offer-drawer--active"),
        requestAnimationFrame((()=>{
            this.style.setProperty("--m-bg-opacity", "0.5"),
            this.cartDrawerInner.style.setProperty("--translate-x", "0")
        }
        )),
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer)
    }
    close() {
        window.cartDrawer.onCartDrawerUpdate();
        this.style.setProperty("--m-bg-opacity", "0"),
        this.cartDrawerInner.style.setProperty("--translate-x", "100%"),
        setTimeout((()=>{
            this.classList.remove("m-cart-special-offer-drawer--active")
        }
        ), 300)
    }
    renderContents(t) {
        this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty"),
        this.productId = t.id,
        
        this.getSectionsToRender().forEach((e=>{
            (e.selector ? document.querySelector(e.selector) : document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector)
        }
        
      
        )),
         
        setTimeout((()=>{
            this.open(),
            window.FoxKitV2 && window.FoxKitV2.Modules.InCart && window.FoxKitV2.Modules.InCart.getCart()
        }
        ))
    }
    updateCartCount(t) {
        document.querySelectorAll(".m-cart-count-bubble").forEach((e=>{
            t > 0 ? (e.textContent = t,
            e.classList.remove("hidden")) : e.classList.add("hidden")
        }
        ))
    }
    getCart() {
        return fetchJSON(this.rootUrl + "cart.json")
    }
    onCartDrawerUpdate(t=!0) {
  
        fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`).then((t=>t.text())).then((e=>{
            this.getSectionsToRender().forEach((r=>{
                if ("cart-items" === r.block) {
                    (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(e, r.selector),
                    window.FoxKitV2 && window.FoxKitV2.Modules.InCart && window.FoxKitV2.Modules.InCart.getCart()
                } else if (t) {
                    (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(e, r.selector)
                }
            }
            ))
        }
        )).catch((t=>{}
        )),
        this.getCart().then((t=>{
            this.classList.toggle("m-cart--empty", 0 === t.item_count),
            this.updateCartCount(t.item_count)
        }
        ))
    }
    getSectionInnerHTML(t, e=".shopify-section") {
     
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML
    }
    getSectionsToRender() {
        return [{
            id: "cart-upgrade-drawer",
            selector: "[data-minimog-cart-items]",
            block: "cart-items"
        }]
    }
    getSectionDOM(t, e=".shopify-section") {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e)
    }
    setActiveElement(t) {
        this.activeElement = t
    }
  }
  customElements.define("m-cart-special-offer-drawer", MCartSpecialOfferDrawer);
